module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/breitling-e36e3d596b7b373459a33315b70da082.png";